import {
  Block,
  BlockProps,
  LabelMedium,
  ListItem,
  ListItemLabel,
} from "@mezo-org/mezo-clay"

type BridgeSummaryListProps = {
  list: { label: string; endEnhancer: string }[]
} & BlockProps

export default function BridgeSummaryList({
  list,
  ...props
}: BridgeSummaryListProps) {
  return (
    <Block as="ul" {...props}>
      {list.map(({ label, endEnhancer }) => (
        <ListItem
          key={label}
          endEnhancer={() => <LabelMedium>{endEnhancer}</LabelMedium>}
          overrides={{
            Content: {
              style: { borderBottom: "none", minHeight: "44px" },
            },
          }}
        >
          <ListItemLabel
            overrides={{
              LabelContent: {
                style: ({ $theme }) => ({
                  color: $theme.colors.contentPrimary,
                }),
              },
            }}
          >
            {label}
          </ListItemLabel>
        </ListItem>
      ))}
    </Block>
  )
}
